import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { FormConfirmationTypeEnum } from '../../../__generated__/graphql';
import RawHtml from '../../../components/RawHtml';
import { Paragraph } from '../../../components/Text';
import { GravityFormFragmentForm } from '../types';

import style from './gravity-form-success.module.css';

interface GravityFormSuccessProps {
  confirmations: GravityFormFragmentForm['confirmations'];
}

const gravityFormSuccessId = 'gravity-form-success';

const GravityFormSuccess = ({
  confirmations,
}: GravityFormSuccessProps) => {
  const router = useRouter();

  const defaultConfirmation = confirmations?.find(confirmation => confirmation?.isDefault);

  useEffect(() => {
    const element = document.getElementById(gravityFormSuccessId);
    const header = document.querySelector('header');

    // 100px is ballpark enough as a fallback to clear the header and ensure visibility
    const headerHeight = header ? (header.getBoundingClientRect().height + 20) : 100;

    if (element) {
      const rect = element.getBoundingClientRect();

      if (rect.top >= headerHeight && rect.bottom <= window.innerHeight) {
        return; // Element is fully visible
      }

      element.scrollIntoView({ behavior: 'instant' });
    }
  }, []);

  if (defaultConfirmation?.type !== FormConfirmationTypeEnum.Message) {
    const redirectUri = defaultConfirmation?.type === FormConfirmationTypeEnum.Redirect
      ? defaultConfirmation.url
      : defaultConfirmation?.page?.node.uri;

    if (redirectUri) {
      void router.push(redirectUri);

      return null;
    }
  }

  if (!defaultConfirmation?.message) {
    return (
      <Paragraph
        className={style.gravityFormSuccess}
        id={gravityFormSuccessId}
      >
        Form successfully submitted - thank you.
      </Paragraph>
    );
  }

  return (
    <RawHtml
      className={style.gravityFormSuccess}
      id={gravityFormSuccessId}
    >
      {defaultConfirmation.message}
    </RawHtml>
  );
};

export default GravityFormSuccess;
